import React from 'react';
import Svg from '../Svg';

const IconPieChart03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 3.05493C6.50005 3.55237 3 7.36745 3 12C3 16.9706 7.02944 21 12 21C13.6184 21 15.137 20.5728 16.4492 19.8251L11.191 12.5878C11.0669 12.4169 11 12.2112 11 12V3.05493ZM13 3.05573V11L20.9443 11C20.8505 10.1614 20.6391 9.3385 20.3149 8.55585C19.8705 7.48285 19.2226 6.50619 18.4073 5.67963C18.3785 5.65047 18.3495 5.62151 18.3204 5.59275C17.4938 4.7774 16.5172 4.12954 15.4442 3.68508C14.6615 3.3609 13.8386 3.14949 13 3.05573ZM20.9443 13L13.9626 13L18.0663 18.6483C18.864 17.9204 19.5263 17.053 20.0191 16.0859C20.5118 15.1189 20.8243 14.0732 20.9443 13ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C15.0045 1 17.7277 2.2046 19.713 4.15719C19.7348 4.17864 19.7565 4.20019 19.7782 4.22183C19.7998 4.24347 19.8214 4.2652 19.8428 4.28701C21.7954 6.27226 23 8.99546 23 12Z"
    />
  </Svg>
);

export default IconPieChart03;
